import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-edit-facebook-modal',
  templateUrl: './edit-facebook-modal.component.html',
  standalone: false,
})
export class EditFacebookModalComponent implements OnInit {
  @Input() currentText: string;
  @Input() facebookLink: string;
  editedText: string;

  constructor(private modalCtrl: ModalController) {}

  ngOnInit() {
    this.editedText = this.currentText;
  }

  save() {
    this.modalCtrl.dismiss({ text: this.editedText });
  }

  cancel() {
    this.modalCtrl.dismiss();
  }

  viewPost() {
    if (this.facebookLink) {
      window.open(this.facebookLink, '_blank');
    }
  }
}